/**
 * DataList empty state display.
 *
 * Renders a centered message when the data list has no items to display.
 * Supports a custom message via props, i18n overrides from config, or
 * arbitrary children for fully custom empty states.
 */

import { Text } from '../../../base/display/Text/Text';
import { useDataListContext } from '../context/DataListContext';
import { DEFAULT_I18N_KEYS } from '../constants';
import type { DataListEmptyProps } from '../types';

export function DataListEmpty({ message, children, className }: Readonly<DataListEmptyProps>) {
  const { config } = useDataListContext();
  const emptyMessage =
    message ?? config.i18n?.emptyMessage ?? DEFAULT_I18N_KEYS.emptyMessage;

  const combinedClasses = [
    'flex flex-col items-center justify-center py-12 text-center',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <output className={combinedClasses}>
      {children ?? <Text color="muted">{emptyMessage}</Text>}
    </output>
  );
}

DataListEmpty.displayName = 'DataListEmpty';
